export default function getResource(label, vars = []) {
    const resources = {
        merchandiseSubtotalText: 'Merchandise Subtotal',
        pickup: 'Pickup',
        free: 'FREE',
        estimatedTaxText: 'Estimated Tax',
        estimatedTaxCA: 'Estimated HST/GST/PST',
        estimatedTotalText: 'Estimated Total',
        paymentText: 'Payment will be collected at the store.',
        reservationDetailsButtonText: 'Continue to Reservation Details',
        completeReservation: 'Complete Reservation',
        bagFeeText: 'Bag Fee',
        specialFeeText: 'Special Fee',
        discountsText: 'Discounts',
        eGiftCardRedeemedText: 'eGift Card Redeemed',
        payPalPaymentText: 'PayPal Payment',
        giftCardRedeemedText: 'Gift Card Redeemed',
        creditCardPaymentText: 'Credit Card Payment',
        storeCredit: 'Store Credit',
        beautyInsiderPoints: 'You will earn Beauty Insider points from this purchase after you pick up the order.',
        orderTotal: 'Order Total',
        gotIt: 'Got It',
        salesTax: 'Sales Tax',
        tax: 'Tax',
        caTax: 'HST/GST/PST'
    };

    return resources[label];
}
